import { Flex, Text } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import { pxToRem } from '@duke-hq/ui/constants/scalable';

export default function ErrorFallback() {
  return (
    <Flex p="2" minH={pxToRem(84)} alignItems="center" justifyContent="center">
      <Text fontSize="sm" fontWeight="medium" color="danger.emphasis">
        <Trans>Unable to load data. Please try again later.</Trans>
      </Text>
    </Flex>
  );
}
